import styled, { css } from "styled-components/native";
import Icon from "react-native-vector-icons/FontAwesome";

import { pickStyle as _, getViewWidth as w } from "utils";
import {
  StarSize,
  ContainerWidth,
  ConatinerMargin,
  StarInnerMargin,
} from "./variables";

export const Container = styled.View`
  width: ${_(ContainerWidth) || "100%"};
  ${props =>
    props.$compact
      ? css`
          margin-top: 0px;
        `
      : css`
          margin-top: ${_(ConatinerMargin) || 90}px;
        `}
  margin-bottom: 80px;
  align-self: center;
  flex-direction: row;
  justify-content: center;
`;

export const Star = styled(Icon)`
  margin: 0px ${_(StarInnerMargin) || w(2)}px;
  font-size: ${_(StarSize) || w(8)}px;
`;
